// SearchDialog.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog, DialogContent } from '../ui/dialog.jsx';
import { Input } from '../ui/input.jsx';
import { Search } from 'lucide-react';
import { BlogPost } from '../../entities/BlogPost';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { stripHtml } from '../../entities/BlogPost';

export default function SearchDialog({ open, onOpenChange }) {
    const { t, i18n } = useTranslation(); // הפעלה
    const [query, setQuery] = React.useState('');
    const [results, setResults] = React.useState([]);
    const [isSearching, setIsSearching] = React.useState(false);

    React.useEffect(() => {
        const searchPosts = async () => {
            if (!query.trim()) {
                setResults([]);
                return;
            }

            setIsSearching(true);
            // העברת השפה הנוכחית לחיפוש
            const posts = await BlogPost.list(i18n.language);
            const filtered = posts.filter(post =>
                post.title.toLowerCase().includes(query.toLowerCase()) ||
                post.content.toLowerCase().includes(query.toLowerCase())
            );
            setResults(filtered);
            setIsSearching(false);
        };

        const debounce = setTimeout(searchPosts, 300);
        return () => clearTimeout(debounce);
    }, [query, i18n.language]); // הוספת השפה כתלות

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="sm:max-w-xl">
                <div className="relative">
                    <Search className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                    <Input
                        value={query}
                        onChange={(e) => setQuery(e.target.value)}
                        placeholder={t('search.placeholder')}
                        className="pr-10 py-6 text-lg bg-gray-900 text-white placeholder-gray-400"
                        autoFocus
                    />
                </div>
                <div className="mt-4 max-h-[60vh] overflow-auto">
                    {isSearching ? (
                        <div className="text-center py-8 text-gray-500">{t('search.searching')}</div>
                    ) : results.length > 0 ? (
                        <AnimatePresence>
                            {results.map((post, index) => (
                                <motion.div
                                    key={post.id}
                                    initial={{ opacity: 0, y: 10 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    exit={{ opacity: 0, y: -10 }}
                                    transition={{ delay: index * 0.05 }}
                                >
                                    <Link
                                        to={`/post/${post.id}`}
                                        onClick={() => onOpenChange(false)}
                                        className="block p-4 hover:bg-gray-50 rounded-lg transition-colors group"
                                    >
                                        <h3 className="font-medium text-lg mb-1 text-gray-200 group-hover:text-gray-900">{post.title}</h3>
                                        {post.excerpt && (
                                            <p className="text-gray-200 text-sm line-clamp-2 group-hover:text-gray-700">
                                                {stripHtml(post.excerpt)}
                                            </p>
                                        )}
                                    </Link>
                                </motion.div>
                            ))}
                        </AnimatePresence>
                    ) : query && !isSearching ? (
                        <div className="text-center py-8 text-gray-500">{t('search.no_results')}</div>
                    ) : null}
                </div>
            </DialogContent>
        </Dialog>
    );
}